<template>
  <b-row>
    <b-col class="text-center">
      <b-form @submit="onSubmit">
        <b-form-group
          id="input-group-name"
          label="Nom"
          label-for="input-name">
          <b-form-input
            id="input-name"
            v-model="form.item_name"
            type="text"
            required
          />
        </b-form-group>

        <b-form-group
          id="input-group-color"
          label="Couleur"
          label-for="input-color">
          <v-swatches
            id="input-color"
            v-model="form.item_color"
            :swatches="swatches"
          />
        </b-form-group>
        <b-button
          type="submit"
          variant="primary">Valider</b-button>
      </b-form>
    </b-col>
  </b-row>
</template>

<script>

import VSwatches from 'vue-swatches';

export default {
  name: 'FormTag',
  components: { VSwatches },
  props: {
    item: {
      type: Object,
      default: null,
    },
    type: {
      type: String,
      default: 'tag',
    },
  },
  data() {
    return {
      form: {
        item_name: null,
        item_id: null,
        item_color: null,
      },
      swatches: [
        '#e7b0d2',
        '#b694C9',
        '#6E8ECA',
        '#5C4BA7',
        '#9BCBDF',
        '#78C2E8',
        '#1C57AE',
        '#7AD0A7',
        '#72C55A',
        '#90DDDC',
        '#67CEB9',
        '#4A9387',
        '#F9C276',
        '#F6915A',
        '#EF7735',
        '#FF6F5D',
        '#F24E3B',
        '#AE2619',
        '#F27D9B',
        '#C25063',
        '#F6498F',
        '#E52D3A',
      ],
    };
  },
  watch: {
    tag: {
      handler(val) {
        if (val) {
          this.form = val;
        }
      },
      deep: true,
    },
  },
  mounted() {
    if (this.item) {
      this.form.item_name = this.item.tag_name;
      this.form.item_id = this.item.tag_id;
      this.form.item_color = this.item.tag_color;

    }
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
      this.$emit('sendForm', JSON.stringify(this.form));
      this.form.item_name = null;
      this.form.item_id = null;
      this.form.item_color = null;
    },
  },
};
</script>

<style scoped>

</style>
